<template>
	<div class="controls"
		v-show="loaded"
		:style="{
			width: `${width}px`,
			height: `${width/16*9}px`,
      top: `${top}px`,
			left: `${left}px`
		}"
		@click.self="playAndPause"
	>
		<div :class="['panel', showPanel&&'pause-show']">
			<div class="panel-box">
				<div class="panel-flex">
					<div class="panel-btn" @click="playAndPause">
						<i :class="[isPlay ? 'play' : 'pause']"></i>
					</div>
					<div class="time-info">{{nowTime | formatTime}}/{{totalTime | formatTime}}</div>
				</div>
				<div class="volume">
					<div></div>
					<i></i>
				</div>
			</div>
			<div class="timeline-content">
				<div class="timeline" :style="{width: `${tWidth}px`}" @click="timelineClick($event)">
					<div class="timeline-track" :style="{'width': nowTime/(totalTime||10)*100 + '%'}"></div>
					<div
						@click.stop
						class="timeline-handle"
						data-action="time"
						v-drag
						:style="{'left': nowTime/(totalTime||10)*100 + '%'}"
					></div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
	name: 'Timeline',
	data() {
		return {
			mpos: {},
			moving: false,
			dragTime: 0
		}
	},
	computed: {
		...mapGetters({
			editor: 'previewTool/editor',
			width: 'previewInit/width',
			top: 'previewInit/top',
			left: 'previewInit/left',
			loaded: 'previewTool/loaded'
		}),
		nowTime() {
			if(this.editor) {
				return this.moving ? this.dragTime : this.editor.nowTime
			}
			return 0
		},
		totalTime() {
			if(this.editor) {
				return this.editor.totalTime
			}
			return 10
		},
		isPlay() {
			if(this.editor) {
				return this.editor.isPlay
			}
			return false
		},
		showPanel() {
			return !this.isPlay || this.moving;
		},
		tWidth() {
			return (this.width || 1072) - 88;
		}
	},
	methods: {
		playAndPause() {
			// if(!document.fullscreenElement) {
			// 	document.getElementsByClassName('control-and-editor')[0].requestFullscreen();
			// } else {
			// 	if(document.exitFullscreen) {
			// 		document.exitFullscreen()
			// 	}
			// }
			this.editor.play({isPlay: !this.isPlay, time: this.nowTime >= this.totalTime ? 0 : this.nowTime})
		},
		timelineClick(e) {
			let time = e.layerX / this.tWidth * this.totalTime;
			time = time < 0 ? 0 : time > this.totalTime ? this.totalTime : time;
			if(this.isPlay) {
				this.editor.play({isPlay: false, time: time});
				setTimeout(() => {
					this.editor.play({isPlay: true, time: time})
				}, 50)
			} else {
				this.editor.play({isPlay: this.isPlay, time: time})
			}
		},
		timeMouseDown(px) {
			this.mpos.dx = px;
			this.mpos.nowTime = this.nowTime;
			this.dragTime = this.nowTime;
			this.moving = true;
		},
		timeMouseMove(px) {
			let dx = (px - this.mpos.dx) / this.tWidth * this.totalTime + this.mpos.nowTime;
			dx = dx < 0 ? 0 : dx > this.totalTime ? this.totalTime : dx;
			this.dragTime = dx;
		},
		timeMouseUp() {
			this.moving = false;
			if(this.isPlay) {
				this.editor.play({isPlay: false, time: this.dragTime});
				setTimeout(() => {
					this.editor.play({isPlay: true, time: this.dragTime});
					this.dragTime = 0;
				}, 50)
			} else {
				this.editor.play({isPlay: this.isPlay, time: this.dragTime})
				this.dragTime = 0;
			}

			this.mpos = {};
		}
	},
	directives: {
		drag(el, _, vnode) {
			let _this = vnode.context,
				action = '',
				mousemove = null,
				mouseup = null;

			mousemove = e => {
				e.preventDefault()
				_this[`${action}MouseMove`](e.pageX, e.pageY)
			}
			mouseup = e => {
				e.preventDefault()
				document.removeEventListener('mousemove', mousemove)
				document.removeEventListener('mouseup', mouseup)
				_this[`${action}MouseUp`](e.pageX, e.pageY)
			}

			el.onmousedown = e => {
				e.preventDefault();
				action = e.target.dataset.action;
				if(!action) return;

				document.addEventListener('mousemove', mousemove)
				document.addEventListener('mouseup', mouseup)

				_this[`${action}MouseDown`](e.pageX, e.pageY)
			}
		}
	},
	filters: {
    formatTime(duration) {
      if (duration <= 0) return "00:00";
      if (!duration) return "--:--";
      let min = ~~(duration / 60);
      min = min.toString().padStart(2, '0');
      let sec = Math.floor(duration % 60);
      sec = sec.toString().padStart(2, '0');
      return min + ":" + sec;
    }
  }
}
</script>
<style lang="scss" scoped>
.controls {
	position: absolute;
	top: 0;
	left: 0;
	width: 1072px;
	height: 603px;

	&:hover{
		.panel {
			opacity: 1;
		}
	}
}
.panel {
	position: absolute;
	bottom: 0;
	left: 0;
	display: flex;
	flex-flow: column;
	justify-content: flex-end;
	width: 100%;
	height: 80px;
	background: image-set(url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAJwCAYAAABI9AvEAAACkklEQVRIS1XHdxQIZBiFcTtCkmRHqSh7U1mpJMlK9t7Jpm2WUFnZK7PsbGWWUfYohOy9NZFVznNP5/vOff/4vfdJkOD/S8iPJCJFYicJKZIGkrEi95AiuZOCFPc6KUmRyklNivsCaViR+0mR1nmAFOmcB0mR3nmIFBmcjKTIFMjMimQhRVYnGykedrKTIofzCCkeDeRkRR4jxePOE6TI5eQmxZPOU6TIE8jLiuQjRX6nACkKOoVIUdgpQoqigWKsSHFSlHBKkqKU8zQpnnGeJUXpQBlWpCwpyjnlSfGcU4EUzzsvkOJFpyIpXgpUYkVeJkVl5xVSVHFeJUVVpxopqgdqsCI1SfGaU4sUrzu1SVHHqUuKeoH6rEgDUjR0GpGisdOEFE2dZqRoHmjBirQkRSunNSnaOG1J8YbTjhRvOu1J0SHQkRXpRIrOThdSdHW6kaK78xYp3g68w4q8S4r3nPdJ8YHTgxQ9nV6k6B3ow4r0JcWHzkek6Od8TIr+zgBSDAx8wop8SorPnEGkGOwMIcVQZxgpPg8MZ0VGkGKkM4oUo50xpBjrjCPFeGcCKSYGvmBFJpFisjOFFFOdaaSY7nxJiq8CM1iRmaSY5cwmxRxnLinmOV+TYn5gASuykBSLnMWkWOIsJcUy5xtSfBtYzoqsIMVKZxUpVjtrSPGd8z0p1jrrSLE+sIEV+YEUPzobSbHJ2UyKLc5WUmwLbGdFdpBip7OLFD85P5Nit7OHFHsDv7Ai+0ix3zlAil+dg6Q45BwmxZHAUVbkGCmOOydIcdI5RYrTzhlSnA2cY0XOk+KCc5EUl5zLpLji/EaK350/SPFn4C9W5G9SXHWukeK68w8pbjg3SXErcJsVuUOKf53/7gIPXjbYDO78kgAAAABJRU5ErkJggg==) 1x) left bottom repeat-x;
	background-size: auto 80px;
	opacity: 0;
	transition: opacity .2s;
	color: #fff;
}
.pause-show {
	opacity: 1;
}
.panel-box {
	width: 100%;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 0 44px 0 34px;
}
.panel-flex {
	display: flex;
	align-items: center;
}
.panel-btn {
	float: left;
	width: 33px;
	height: 33px;
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 50%;
	cursor: pointer;

	&:hover {
		background-color: rgba(0, 0, 0, .4);
	}

	i {
		display: block;
		height: 15px;
		width: 15px;


		&.play {
			background: url(./images/pause.svg) no-repeat center;
			background-size: 15px 15px;
		}
		&.pause {
			background: url(./images/play.svg) no-repeat center;
			background-size: 15px 15px;
		}
	}
}
.time-info {
	font-weight: 600;
	margin-left: 9px;
}
.volume {
	opacity: 0;
	float: right;
	width: 151px;
	height: 25px;
	padding: 0 10px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	background-color: rgba(0, 0, 0, .4);
	border-radius: 13px;
	opacity: 0;

	div {
		width: 108px;
		height: 3px;
		border-radius: 2px;
		background-color: #fff;
	}

	i {
		display: block;
		height: 13px;
		width: 15px;
		background: url(./images/volume.svg) no-repeat center;
		background-size: 15px 15px;
	}
}
.timeline-content {
	width: 100%;
	height: 34px;
	display: flex;
	justify-content: center;
	padding-top: 8px;
}
.timeline {
	position: relative;
	top: 0;
	left: 0;
	width: 984px;
	height: 6px;
	background-color: rgba(255, 255, 255, .4);
	border-radius: 3px;
	cursor: pointer;

	&-track {
		position: absolute;
		top: 0;
		left: 0;
		height: 100%;
		background-color: #fff;
		cursor: pointer;
		border-radius: 3px;
	}
	&-handle {
		position: absolute;
		margin-left: -7px;
		margin-top: -7px;
		top: 0;
		width: 20px;
		height: 20px;
		background-color: #fff;
		border-radius: 50%;
		// transition: left .1s;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/draftPreview/Controls.vue